import { PNGIconName, pngIcons } from '../../../constants/pngIcon';

interface PngIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  name: PNGIconName;
}

export const PngIcon: React.FC<PngIconProps> = ({ name, ...props }) => {
  const iconSrc = pngIcons[name];
  return <img src={iconSrc} alt={name} {...props} />;
};
